import {
  FilterTag,
  FilterTagChild,
} from "features/filters/components/FilterTag";

import CompanyImage from "common/components/ui/CompanyImage";
import ProfileImage from "common/components/ui/ProfileImage";
import type {
  GenericSearchParam,
  LinkedInProfile,
  SearchParamWithImage,
} from "common/types";

import type { ReactNode } from "react";

type SearchOption = GenericSearchParam | SearchParamWithImage | LinkedInProfile;

interface SelectionTagsProps {
  selection: SearchOption[];
  onRemoveFilter: (option: SearchOption) => void;
}

export default function SelectionTags({
  selection,
  onRemoveFilter,
}: SelectionTagsProps) {
  return (
    <div className="mt-1.5 flex flex-wrap gap-1.5 px-2">
      {selection.map((option) => {
        // profiles and companies have an image and a different label key
        let leftComponent: ReactNode;
        let label: string;

        if ("full_name" in option) {
          label = option.full_name;
          leftComponent = <ProfileImage size="3xs" src={option.picture_url} />;
        } else if ("logo_url" in option) {
          label = option.name;
          leftComponent = <CompanyImage size="3xs" src={option.logo_url} />;
        } else {
          label = option.name;
        }

        return (
          <FilterTag key={option.urn} onRemove={() => onRemoveFilter(option)}>
            <FilterTagChild>
              {leftComponent}
              {label}
            </FilterTagChild>
          </FilterTag>
        );
      })}
    </div>
  );
}
